import {
  Code2,
  Search,
  Palette,
  Megaphone,
  ShieldCheck,
  PenTool,
} from "lucide-react";

export const SERVICES = [
  {
    slug: "website-development",
    icon: Code2,
    title: "Website Development",
    tagline: "Custom-coded, conversion-engineered websites.",
    description:
      "Custom-coded, conversion-engineered websites built for speed, scale and search.",
    benefits: ["Sub-1s load times", "Pixel-perfect UI", "CMS or static"],
  },
  {
    slug: "seo-geo",
    icon: Search,
    title: "SEO & GEO",
    tagline: "Rank on Google AND get cited by ChatGPT, Gemini & Perplexity.",
    description:
      "Rank in Google AND get cited by ChatGPT, Gemini, Perplexity & Copilot through Generative Engine Optimization.",
    benefits: ["Technical SEO", "Generative Engine Opt.", "Topical authority"],
  },
  {
    slug: "branding",
    icon: Palette,
    title: "Branding",
    tagline: "Premium identity systems for category leaders.",
    description:
      "Identity systems that look like they belong in the top 1% of your industry.",
    benefits: ["Logo & marks", "Brand guidelines", "Visual systems"],
  },
  {
    slug: "marketing-strategy",
    icon: Megaphone,
    title: "Marketing Strategy",
    tagline: "Custom channel plans tied to revenue.",
    description:
      "Channel plans built around your unit economics — not generic playbooks.",
    benefits: ["Funnel design", "Paid + organic", "Lifecycle"],
  },
  {
    slug: "maintenance",
    icon: ShieldCheck,
    title: "Maintenance",
    tagline: "Hands-off uptime, security & optimization.",
    description:
      "Hands-off uptime, security patches, backups and continuous optimization.",
    benefits: ["24/7 monitoring", "Weekly backups", "Speed audits"],
  },
  {
    slug: "content-writing",
    icon: PenTool,
    title: "Content Writing",
    tagline: "AI-augmented content engineered to rank & convert.",
    description:
      "AI-augmented, human-edited content engineered to rank and convert.",
    benefits: ["SEO articles", "Landing copy", "Email & ads"],
  },
];

export const getServiceBySlug = (slug) =>
  SERVICES.find((s) => s.slug === slug);
